import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Button,
  Alert,
  Spinner,
  Badge,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
import { Multiselect } from "multiselect-react-dropdown";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import location from "../../../images/location.png";

function AddMarkerToClick(props) {
  var L = window.L;
  var myIcon = L.icon({
    iconUrl: location,
    iconSize: [20, 35],
  });
  const [lat, setLat] = useState(0);
  const [lng, setLng] = useState(0);
  useEffect(() => {
    props.setMapShow(false);
    setLat(props.lattitude);
    setLng(props.longitude);
    props.setMapShow(true);
  }, [props.longitude, props.lattitude]);
  const map = useMapEvents({
    click(e) {
      props.setLattitude(e.latlng.lat);
      props.setLongitude(e.latlng.lng);
      props.setMarkerStatus(false);
      setLat(e.latlng.lat);
      setLng(e.latlng.lng);
      //  setTimeout(()=>{
      //   props.setMapShow(false)
      //   props.setMapShow(true)
      //  },500)
    },
  });
  return (
    <>
      <Marker icon={myIcon} position={[lat, lng]}></Marker>
    </>
  );
}
function HealthCenter() {
  var history = useHistory();
  //const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [data, setData] = useState("");
  const [allCenter, setAllCenter] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [longitude, setLongitude] = useState("");
  const [imageKey, setImageKey] = useState("");
  const [imageData, setImageData] = useState(null);
  const [centerDesc, setCenterDesc] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [contact, setContact] = useState("");
  const [image, setImage] = useState(null);
  const [centerName, setCenterName] = useState("");
  const [lattitude, setLattitude] = useState("");
  const [testID, setTestId] = useState("");
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [popular, setPopular] = useState(false);
  const [labTest, setLabTest] = useState(false);
  const [featured, setFeatured] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [allPackage, setAllPackages] = useState([]);
  const [allTest, setAllTest] = useState([]);
  const [packageId, setPackageId] = useState("");
  const [alltestID, setAllTestId] = useState("");
  const [areaName, setAreaName] = useState("");
  const [cityName, setCityName] = useState("");
  const [email, setEmail] = useState("");
  const [auto, setAuto] = useState(false);
  const [mapShow, setMapShow] = useState(true);
  const [markerStatus, setMarkerStatus] = useState(false);
  const mapRef = useRef(null);
  function getData() {
    axios
      .get(Baseurl.baseurl3 + "/health/get-all-health-center-info")
      .then((res) => {
        setSpinner(false);
        setAllCenter(res.data.data);
        setSearchData(res.data.data);
        setData(document.querySelectorAll("#job_data tbody tr"));
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      let phoneString = val.riderPhone.toString();
      if (
        val.riderFirstName.toLowerCase().includes(value) ||
        val.riderLastName.toLowerCase().includes(value) ||
        val.riderEmail.toLowerCase().includes(value) ||
        phoneString.includes(value)
      ) {
        filteredData.push(val);
      }
    });
    setAllCenter(filteredData);
  }
  const onChangePicture = (e) => {
    if (e.target.files[0].size / 1048576 < 3) {
      setImage(e.target.files[0]);
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImageData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null);
    }
  };
  function addTest() {
    const data = new FormData();
    data.append("name", centerName);
    data.append("email", email);
    data.append("desc", centerDesc);
    data.append("lat", lattitude);
    data.append("lng", longitude);
    data.append("address", address);
    data.append("pincode", pincode);
    data.append("contact", contact);
    data.append("areaName", areaName);
    data.append("cityName", cityName);
    data.append("labTest", labTest);
    data.append("image", image);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl3}/health/create-health-center`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setCenterName("");
          setImage(null);
          setImageData(null);
          setCenterDesc("");
          setAddress("");
          setPincode("");
          setLongitude("");
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function updateTest() {
    let testFields = {
      name: centerName,
      desc: centerDesc,
      lat: lattitude,
      lng: longitude,
      address: address,
      pincode: pincode,
      contact: contact,
      areaName: areaName,
      cityName: cityName,
      email: email,
      labTest: labTest,
    };
    axios
      .put(
        Baseurl.baseurl3 + `/health/update-health-center-info/${testID}`,
        testFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function addFields(val) {
    let testFields = [];
    if (val === "popular") {
      testFields = {
        popular: !popular,
      };
    }
    if (val === "featured") {
      testFields = {
        featured: !featured,
      };
    }
    if (val === "isnew") {
      testFields = {
        new: !isNew,
      };
    }
    axios
      .put(
        Baseurl.baseurl3 + `/health/update-health-center-${val}/${testID}`,
        testFields
      )
      .then((response) => {
        getData();
        // if (response.data.status) {
        //   swal("Added", response.data.message, "success", {
        //     button: "Done",
        //     timer: 1000,
        //   });
        // } else {
        //   swal("Oops", response.data.message, "error", {
        //     button: "Done",
        //     timer: 1000,
        //   });
        // }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updateTestImage() {
    const data = new FormData();
    data.append("image", image);
    data.append("testImageKey", imageKey);

    var config = {
      method: "put",
      url: `${Baseurl.baseurl3}/health/update-health-center-image/${testID}`,
      data: data,
    };
    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();

          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function deleteCenter() {
    axios
      .delete(Baseurl.baseurl3 + `/health/delete-health-center-by-id/${testID}`)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }
  const selection1 = (selectedValues) => {
    let id = [];
    selectedValues.map((val) => {
      id.push(val._id);
    });
    setPackageId(id);
  };
  function addPackageToCategory() {
    let testArray = {
      pID: packageId,
    };
    axios
      .put(
        Baseurl.baseurl3 + `/health/add-package-to-health-center/${testID}`,
        testArray
      )
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  const selection2 = (selectedValues) => {
    console.log("selected", selectedValues);
    let id = [];
    selectedValues.map((val) => {
      id.push(val._id);
    });
    setAllTestId(id);
  };
  function addTestToCategory() {
    let testArray = {
      testID: alltestID,
    };
    axios
      .put(
        Baseurl.baseurl3 + `/health/add-test-to-health-center/${testID}`,
        testArray
      )
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function getAllPackages(value) {
    axios
      .get(Baseurl.baseurl3 + "/health/get-all-health-package-info")
      .then((res) => {
        let filterArray = res.data.data;
        filterArray = filterArray.filter(function (obj) {
          return !this.has(obj._id);
        }, new Set(value.map((obj) => obj._id)));
        setAllPackages(filterArray);
      });
  }
  function getAllTests(value) {
    axios.get(Baseurl.baseurl3 + "/health/get-all-health-test").then((res) => {
      let filterArray = res.data.data;
      filterArray = filterArray.filter(function (obj) {
        return !this.has(obj._id);
      }, new Set(value.map((obj) => obj._id)));
      setAllTest(filterArray);
    });
  }
  function removePackages(val, centerId) {
    let testFields = {
      pID: val,
    };
    axios
      .put(
        Baseurl.baseurl3 +
          `/health/remove-package-to-health-center/${centerId}`,
        testFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("removed", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function removeTests(val, centerId) {
    let testFields = {
      testID: val,
    };
    axios
      .put(
        Baseurl.baseurl3 + `/health/remove-test-to-health-center/${centerId}`,
        testFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("removed", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updateFunction(val) {
    setMapShow(false);
    setShow(true);
    setUpdateStatus(true);
    setCenterName(val.Name);
    setCenterDesc(val.Description);
    setLattitude(val.Lat);
    setAddress(val.Address);
    setLongitude(val.Lng);
    setPincode(val.Pincode);
    setImageData(val.Image);
    setTestId(val._id);
    setPopular(val.Popular);
    setFeatured(val.Featured);
    setIsNew(val.IsNew);
    setImageKey(val.ImageKey);
    getAllPackages(val.Packages);
    getAllTests(val.Tests);
    setContact(val.Contact);
    setCityName(val.CityName);
    setAreaName(val.AreaName);
    setEmail(val.Email);
    setLabTest(val.LabTest);
    setTimeout(() => {
      setMapShow(true);
      setMarkerStatus(true);
    }, 100);
  }
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Test</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Are You Sure You Want to Delete This Test ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              deleteCenter();
            }}
            className="btn btn-primary"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Test</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row">
              <div className="col-sm-2 mt-2">
                <label>
                  Center Name <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={centerName}
                  type="text"
                  className="form-control"
                  placeholder="enter center Name"
                  onChange={(e) => setCenterName(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
                  Description<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <textarea
                  value={centerDesc}
                  type="text"
                  className="form-control"
                  placeholder="enter Description"
                  onChange={(e) => setCenterDesc(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-sm-2 mt-2">
                <label>
                  Email<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={email}
                  type="text"
                  className="form-control"
                  placeholder="enter email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
                  Contact <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={contact}
                  type="text"
                  className="form-control"
                  placeholder="enter contact"
                  maxLength={10}
                  onChange={(e) => setContact(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-2 mt-2">
                <label>
                  Address<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <textarea
                  value={address}
                  type="text"
                  className="form-control"
                  placeholder="enter Address"
                  onChange={(e) => setAddress(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
                  Pincode<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={pincode}
                  type="number"
                  className="form-control"
                  placeholder="enter pincode"
                  onChange={(e) => setPincode(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-sm-2 mt-2">
                <label>
                  City Name <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={cityName}
                  type="text"
                  className="form-control"
                  placeholder="enter city Name"
                  onChange={(e) => setCityName(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
                  Area Name<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <textarea
                  value={areaName}
                  type="text"
                  className="form-control"
                  placeholder="enter Area Name"
                  onChange={(e) => setAreaName(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-4 mb-4">
              <div className="col-sm-2">
                <label className="mt-2">Auto Select Location</label>
              </div>
              <div className="col-sm-4 mt-1">
                <Switch
                  onColor="#135334"
                  onChange={() => {
                    setMapShow(false);
                    setAuto(!auto);
                    if (!auto) {
                      let location = null;
                      if (window.navigator && window.navigator.geolocation) {
                        location = window.navigator.geolocation;
                      }
                      if (location) {
                        location.getCurrentPosition(function (position) {
                          setLattitude(position.coords.latitude);
                          setLongitude(position.coords.longitude);
                          setMapShow(true);
                        });
                      }
                    } else {
                      setMapShow(true);
                      setLattitude(0);
                      setLongitude(0);
                    }
                  }}
                  checked={auto}
                />
              </div>
            </div>
            <div className="text-center" style={{ fontSize: "14px" }}>
              click in the map for Lattitude & Longitude Selection
            </div>
            {mapShow && (
              <MapContainer
                ref={mapRef}
                style={{
                  height: window.innerHeight / 1.64,
                  width: window.innerWidth / 1.18,
                }}
                center={[lattitude, longitude]}
                bounds={[lattitude, longitude]}
                zoom={30}
                scrollWheelZoom={true}
              >
                <AddMarkerToClick
                  setMapShow={setMapShow}
                  lattitude={lattitude}
                  longitude={longitude}
                  setLattitude={setLattitude}
                  setLongitude={setLongitude}
                  setMarkerStatus={setMarkerStatus}
                />
                <TileLayer
                  url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                  maxZoom={21}
                  minZoom={4}
                  minZoomIsDrawing={18}
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
                {markerStatus && (
                  <Marker position={[lattitude, longitude]}></Marker>
                )}
              </MapContainer>
            )}
            <div
              className="text-center mt-3"
              style={{ fontSize: "19px", fontWeight: "600" }}
            >
              OR{" "}
            </div>
            <div
              className="text-center mt-3"
              style={{ fontSize: "16px", fontWeight: "600" }}
            >
              Add Lattitude and Longitude of Center manually{" "}
            </div>
            <div className="row mt-4">
              <div className="col-sm-2 mt-2">
                <label>
                  Lattitude <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={lattitude}
                  type="number"
                  className="form-control"
                  placeholder="enter lattitude"
                  onChange={(e) => setLattitude(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
                  Longitude<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4 ">
                <input
                  value={longitude}
                  type="number"
                  className="form-control"
                  placeholder="enter longitude"
                  onChange={(e) => setLongitude(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-2 mr-3">
                <label htmlFor="val-range">
                  Center Image
                  <span className="text-danger">*</span>
                </label>
              </div>
              <div classname="col-sm-4">
                <div className="register_profile_image mt-2">
                  <input
                    id="profilePic"
                    type="file"
                    onChange={(e) => {
                      onChangePicture(e);
                    }}
                  />
                </div>
                {imageData && (
                  <div
                    style={{
                      marginTop: "5px",
                      width: 180,
                      height: 100,
                      aspectRatio: 1 * 1.4,
                    }}
                    className="previewProfilePic"
                  >
                    <img
                      alt=""
                      className="playerProfilePic_home_tile"
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      src={imageData}
                    />
                  </div>
                )}
              </div>
              <div className="col-sm-4 mt-5">
                {updateStatus && (
                  <button
                    onClick={() => {
                      updateTestImage();
                    }}
                    className="btn btn-primary mt-3"
                  >
                    Change
                  </button>
                )}
              </div>
            </div>
            <div className="row mt-3">
              <div className=" col-sm-2 mt-1">
                <label>Lab Test</label>
              </div>
              <div className="col-sm-2">
                <Switch
                  onChange={() => {
                    setLabTest(!labTest);
                  }}
                  checked={labTest}
                />
              </div>
            </div>
            {updateStatus && (
              <>
                <div className="row mt-2">
                  <div className="col-sm-4 mb-5" id="multiselect">
                    <label>Packages</label>
                    <Multiselect
                      options={allPackage}
                      displayValue="Name"
                      onSelect={selection1}
                    />
                  </div>
                  <div className="col-sm-2 mt-4">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        addPackageToCategory();
                      }}
                    >
                      Add
                    </button>
                  </div>
                  <div className="col-sm-4 mb-5" id="multiselect">
                    <label>Tests</label>
                    <Multiselect
                      options={allTest}
                      displayValue="Name"
                      onSelect={selection2}
                    />
                  </div>
                  <div className="col-sm-2 mt-4">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        addTestToCategory();
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-sm-2">
                    <label>Popular</label>
                  </div>
                  <div className="col-sm-1">
                    <Switch
                      onChange={() => {
                        setPopular(!popular);
                        addFields("popular");
                      }}
                      checked={popular}
                    />
                  </div>
                  <div className="col-sm-2">
                    <label>Featured</label>
                  </div>
                  <div className="col-sm-1">
                    <Switch
                      onChange={() => {
                        setFeatured(!featured);
                        addFields("featured");
                      }}
                      checked={featured}
                    />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-sm-2">
                    <label>New</label>
                  </div>
                  <div className="col-sm-1">
                    <Switch
                      onChange={() => {
                        setIsNew(!isNew);
                        addFields("isnew");
                      }}
                      checked={isNew}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                updateTest();
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addTest();
              }}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background: "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              setShow(true);
              setUpdateStatus(false);
              setCenterName("");
              setCenterDesc("");
              setLattitude("");
              setAddress("");
              setLongitude("");
              setPincode("");
              setContact("");
              setCityName("");
              setAreaName("");
              setEmail("");
              setImageData(null);
            }}
            className="btn btn-primary"
          >
            Add Center
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>Image</strong>
                    </th>
                    <th>
                      <strong>Name</strong>
                    </th>
                    <th>
                      <strong>Address</strong>
                    </th>

                    <th>
                      <strong>Description</strong>
                    </th>
                    {/* <th>
                      <strong>Pincode</strong>
                    </th> */}
                    {/* <th>
                      <strong>Lattitude</strong>
                    </th>
                    <th>
                      <strong>Longittude</strong>
                    </th> */}
                    {/* <th>
                      <strong className="col-sm-12">Packages</strong>
                    </th>
                    <th>
                      <strong className="col-sm-12">Tests</strong>
                    </th> */}
                    <th>
                      <strong>Email</strong>
                    </th>
                    <th>
                      <strong>Phone</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: "13px" }}>
                  {allCenter &&
                    allCenter.map((val, key) => (
                      <tr key={val.id}>
                        <td>
                          <div className="profile-photo">
                            <img
                              src={val.Image}
                              style={{ height: 50, width: 50 }}
                              alt="profile"
                            />
                          </div>
                        </td>
                        <td>{val.Name}</td>
                        <td>
                          {val.Address}
                          {val.Pincode}
                        </td>
                        <td>{val.Description}</td>
                        <td>{val.Email}</td>
                        <td>{val.Contact}</td>
                        {/* <td>{val.Pincode}</td> */}
                        {/* <td>{val.Lat}</td>
                        <td>{val.Lng}</td> */}
                        {/* <td className="col-sm-7" >
                        {val.Packages.map((test) => {
                              return (
                                <div className="row">
                                  <div className="col-sm-8  text-sm">
                                    <strong>{test.Name}</strong>
                                  </div>
                                  <div className="col-sm-2 ">
                                    <Link
                                      onClick={() => {
                                        removePackages(test._id,val._id);
                                      }}
                                      href="#"
                                      className="btn btn-danger shadow btn-xs sharp"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </Link>
                                  </div>
                                </div>
                              );
                            })}
                        </td> */}
                        {/* <td className="col-sm-8">
                        {val.Tests.map((test) => {
                              return (
                                <div className="row">
                                  <div className="col-sm-8 text-sm ">
                                    <strong>{test.Name}</strong>
                                  </div>
                                  <div className="col-sm-2  m-0">
                                    <Link
                                      onClick={() => {
                                        removeTests(test._id,val._id);
                                        
                                      }}
                                      href="#"
                                      className="btn btn-danger shadow btn-xs sharp"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </Link>
                                  </div>
                                </div>
                              );
                            })}
                        </td> */}
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  history.push(
                                    `/View-Health-Order-List/${val._id}`
                                  );
                                }}
                              >
                                Orders
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setTestId(val._id);
                                  setShow1(true);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allCenter && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allCenter
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default HealthCenter;
